import { Input } from "antd"
import { Colors } from "@config"
import { twMerge } from "tailwind-merge"

export default function TextInput({ ...rest }) {
    return <div className="relative">
        <Input
            type={rest?.type || "text"}
            style={{ backgroundColor: Colors.LightGray }}
            className={twMerge("bg-neutral-50 border-[2px] border-transparent font-semibold text-gray-800 rounded-full focus:border-primary block w-full py-4 px-6 placeholder:text-gray-400 placeholder:font-semibold", rest.fieldClasses)}
            {...rest}
        />
    </div>
}